export * from './info-icon'
